import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { callcenterService } from '../../api/callcenterService';
import { Card, CardHeader, CardTitle, CardContent, Button, Input, Label } from '../ui';
import toast from 'react-hot-toast';

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const data = await callcenterService.getUsers();
      setUsers(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
      toast.error('Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (ext) => {
    if (!window.confirm(`Delete user ${ext}?`)) return;
    try {
      await callcenterService.deleteUser(ext);
      toast.success('User deleted');
      load();
    } catch (e) {
      console.error(e);
      toast.error('Delete failed');
    }
  };

  const filtered = users.filter((u) =>
    (u?.extension || u)?.toString().toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Call Center Users</CardTitle>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2">
                <Label htmlFor="filter">Filter</Label>
                <Input
                  id="filter"
                  placeholder="Search by extension..."
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>
              <Button asChild>
                <Link to="/callcenter/users/new">Create User</Link>
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left">#</th>
                    <th className="px-4 py-2 text-left">Extension</th>
                    <th className="px-4 py-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 ? (
                    <tr>
                      <td className="px-4 py-3 border-t" colSpan={3}>No users</td>
                    </tr>
                  ) : (
                    filtered.map((u, idx) => {
                      const ext = u?.extension || u;
                      return (
                        <tr key={ext}>
                          <td className="px-4 py-3 border-t">{idx + 1}</td>
                          <td className="px-4 py-3 border-t font-mono">{ext}</td>
                          <td className="px-4 py-3 border-t">
                            <Button variant="destructive" onClick={() => onDelete(ext)}>
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default UsersList;

